/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Cashback Reserve Modal error component
 *
 * @author Yakov Gushchin
 * @author Julia Ignatieva
 * @version 1.13.0
 * @since 1.12.0
 */

import { useEffect } from 'react';

import { Button } from '../../../../../components/common';
import { ImgStatusError } from '../../../../../components/common/Block/Img';
import GTMOperations from '../../../../../modules/analytics/GoogleTagManager/GTMOperations';
import { IGTMPushAnalyticPayload } from '../../../../../modules/analytics/GoogleTagManager/types/GTMActionTypes';
import Modal from '../../../../../modules/modal/components/Modal';
import { stringFormatParams } from '../../../../../utils/stringFormat';
import { CashbackReserveModalStatusStyled } from '../../styled/CashbackReserveModalStyled';
import { ICashbackReserveModal } from './CashbackReserveModal';

export type TCashbackReserveModalFailure =
    Pick<ICashbackReserveModal, 'service' | 'translation' | 'translationCommon' | 'onCloseModal'> & {
    pushGtmAnalytic: (payload: IGTMPushAnalyticPayload) => void;
    reserveError: string[];
};

const CashbackReserveModalFailure = (props: TCashbackReserveModalFailure) => {

    const {
        reserveError,
        service,
        translation,
        translationCommon,

        onCloseModal,
        pushGtmAnalytic,
    } = props;

    useEffect(() => {
        pushGtmAnalytic({
            operation: GTMOperations.cashback.clickOnReserveFail(
                stringFormatParams(translation.start.title, { name: service.title }),
                reserveError[0],
            ),
            withAccountType: true,
            withSusrId: true,
            withUserRole: true,
        });
    }, [pushGtmAnalytic, reserveError, service.title, translation.start.title]);

    return (
        <CashbackReserveModalStatusStyled>
            <ImgStatusError/>
            <Modal.Title className="modal-popup-title">{reserveError[0]}</Modal.Title>
            {reserveError[1] && <Modal.Text>{reserveError[1]}</Modal.Text>}
            <Modal.Control>
                <Button kind="medium" onClick={onCloseModal}>{translationCommon.modal.accessibly}</Button>
            </Modal.Control>
        </CashbackReserveModalStatusStyled>
    );
};

export default CashbackReserveModalFailure;
